module.exports = __webpack_public_path__ + "img/favicon.c68ed543.jpg";